//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ionLogoGithub } from '@quasar/extras/ionicons-v4';

export default {
  created () {
    this.ionLogoGithub = ionLogoGithub;
  }
}
